type LocationMapProps = {
  location: string;
};

export const LocationMap = ({ location }: LocationMapProps) => {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

  if (!location || !apiKey) {
    return (
      <div className='w-full h-48 bg-gray-100 rounded-xl flex items-center justify-center text-sm text-gray-400'>
        Location not available
      </div>
    );
  }

  const src = `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${encodeURIComponent(location)}`;

  return (
    <div className='w-full h-52 rounded-xl overflow-hidden mt-3'>
      <iframe
        title={`Map of ${location}`}
        src={src}
        width='100%'
        height='100%'
        style={{ border: 0 }}
        allowFullScreen
        loading='lazy'
        referrerPolicy='no-referrer-when-downgrade'
      />
    </div>
  );
};
